import {apiErrorHandler} from '../services/api_error_handler/api_error_handler';

import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_DIGIDIARY_EXPERIENCE_API,
});

const OKTA_TOKEN_STORAGE = 'okta-token-storage';

export const setupAxiosClientDD = ({dispatch, getState}, axiosInstance) => {
  const onRequestSuccess = (config) => {
    config.headers['trace_id'] = localStorage.getItem('trace-id');
    let oktaTokenStoage =
      window.localStorage.getItem(OKTA_TOKEN_STORAGE) &&
      JSON.parse(window.localStorage.getItem(OKTA_TOKEN_STORAGE));
    if (oktaTokenStoage.accessToken) {
      config.headers['Authorization'] = `${oktaTokenStoage.accessToken.value}`;
    } else {
      apiErrorHandler('sign out', 'SIGN_OUT', true, '/signOut');
    }
    return config;
  };

  const onRequestError = (error) => Promise.reject(error.response);

  const onResponseSucess = (response) => response;
  const onResponseError = (error) => Promise.reject(error);

  axiosInstance.interceptors.request.use(onRequestSuccess, onRequestError);
  axiosInstance.interceptors.response.use(onResponseSucess, onResponseError);
};

export default instance;
